import authenticted from '../http-clients/authenticated'

export default{
  index({tenantId,  knowledgecheckId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions`,
      method: 'get'
    })
  },
  archived({tenantId,  knowledgecheckId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions/archived`,
      method: 'get'
    })
  },
  show({tenantId,  knowledgecheckId, questionId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions/${questionId}`,
      method: 'get'
    })
  },
  store({tenantId,  knowledgecheckId,data}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions`,
      method: 'post',
      data
    })
  },
  update({tenantId,  knowledgecheckId, questionId, data}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions/${questionId}`,
      method: 'put',
      data
    })
  },
  destroy({tenantId,  knowledgecheckId, questionId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions/${questionId}`,
      method: 'delete'
    })
  },
  restore({tenantId,  knowledgecheckId, questionId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions/${questionId}/restore`,
      method: 'put'
    })
  },
  order({tenantId,  knowledgecheckId, data}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/questions/order`,
      method: 'put',
      data: {
        questions: data
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/knowledgechecks/questions.js